import React, { Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Modal, message } from 'antd';
import Util from '../../../script/util';
import HTTP from '../../../script/service';
import './authentication.scss';
import CusUpload from '../../cusUpload/CusUpload';

// eslint-disable-next-line no-useless-escape
const RealNameReg = /^([\u4e00-\u9fa5+\·?\u4e00-\u9fa5+]{2,30}$)/;

class ManualAuthentication extends Component {
  state = {
    visible: false,
    realName: '',
    certNo: '',
    certFrontPic: '',
    certReversePic: '',
  };
  showModal = (params = { certNo: '', realName: '' }) => {
    this.setState({
      visible: true,
      certNo: params.certNo,
      realName: params.realName,
    });
  };
  close = () => {
    this.setState({
      visible: false,
    });
  };
  commit = () => {
    const { realName, certNo, certFrontPic, certReversePic } = this.state;
    if (!realName || realName.length < 2) {
      message.error('请填写真实姓名');
      return;
    }
    if (!RealNameReg.test(realName)) {
      message.error('请正确填写您的真实姓名');
      return;
    }
    if (!certNo) {
      message.error('请填写身份证号码');
      return;
    }
    if (certNo.length !== 18) {
      message.error('请正确填写身份证号码');
      return;
    }
    let birthday = certNo.substr(6, 8);
    birthday =
      birthday.slice(0, 4) +
      '-' +
      birthday.slice(4, 6) +
      '-' +
      birthday.slice(6);
    const age = Util.birthdayCalcAge(birthday);
    if (age < 18) {
      message.warning('请提供18岁到45岁之间的身份证信息');
      return;
    }
    if (!certFrontPic) {
      message.error('请上传证件正面');
      return;
    }
    if (!certReversePic) {
      message.error('请上传证件背面');
      return;
    }

    HTTP._v4_realNameCertAuth({
      uid: this.props.base.uid,
      realName,
      certNo,
      certFrontPic,
      certReversePic,
      ifAuth: 1,
    }).then((res) => {
      if (res.code == 200) {
        this.props.callback && this.props.callback();
        this.close();
      } else {
        message.error(res.message || '提交失败，请稍后重试');
      }
    });
  };
  changeRealName = (e) => {
    this.setState({
      realName: e.target.value,
    });
  };
  changeCertNo = (e) => {
    this.setState({
      certNo: e.target.value,
    });
  };
  uploadIdentityImg = (field, res) => {
    if (res) {
      this.setState({ [field]: res.default });
    }
  };
  render() {
    const { realName, certNo, certFrontPic, certReversePic, visible } =
      this.state;
    const { close, changeRealName, changeCertNo, uploadIdentityImg, commit } =
      this;
    const { base } = this.props;
    const uploadHeader = {
      authorization: base.token,
      uid: base.uid,
    };
    return (
      <Modal
        destroyOnHidden={true}
        footer={null}
        centered={true}
        open={visible}
        className="daidai-modal-style has-top-border host-step-container"
        width="800px"
        title={'实名认证'}
        onCancel={close}
        maskClosable={false}
      >
        <div className="host-enter-auth host-enter-tab">
          <div className="auth-form host-enter-tabcontent">
            <div className="info-form-row">
              <span className="info-form-label">真实姓名 :</span>
              <input
                className="info-form-input"
                autoComplete="off"
                placeholder="请输入您的真实姓名"
                value={realName}
                onChange={changeRealName}
                maxLength="15"
              />
            </div>
            <div className="info-form-row">
              <span className="info-form-label">身份证号 :</span>
              <input
                className="info-form-input"
                autoComplete="off"
                placeholder="请输入您提现银行卡绑定的身份证号"
                value={certNo}
                onChange={changeCertNo}
              />
            </div>
            <div className="info-form-row">
              <span className="info-form-label">身份证照片 :</span>
              <span className="info-form-tip">
                JPG\PNG格式，大小为2M内，尺寸最小800*500
              </span>
            </div>
            <ul className="identity-card-ul">
              <li className="identity-card">
                <div className="identity-img front">
                  {certFrontPic ? (
                    <img
                      src={Util.transImgUrl(certFrontPic)}
                      alt="certFrontPic"
                      className="identity-pic"
                    />
                  ) : null}
                </div>
                <CusUpload
                  size={2}
                  onChange={uploadIdentityImg.bind(this, 'certFrontPic')}
                  headers={uploadHeader}
                >
                  <div className="identity-btn">上传身份证正面</div>
                </CusUpload>
              </li>
              <li className="identity-card">
                <div className="identity-img rear">
                  {certReversePic ? (
                    <img
                      src={Util.transImgUrl(certReversePic)}
                      alt="certReversePic"
                      className="identity-pic"
                    />
                  ) : null}
                </div>
                <CusUpload
                  size={2}
                  onChange={uploadIdentityImg.bind(this, 'certReversePic')}
                  headers={uploadHeader}
                >
                  <div className="identity-btn">上传身份证背面</div>
                </CusUpload>
              </li>
            </ul>
            <div className="form-btns">
              <button className="daidai-btn-primary" onClick={commit}>
                提交
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
export default withRouter(ManualAuthentication, { withRef: true });
